export const SEMESTER_MONTHS = {
  1: ['August', 'September', 'October', 'November', 'December'],
  2: ['January', 'February', 'March', 'April', 'May']
};

export const DEFAULT_SEMESTER_SUBJECTS = {
  1: [
    { id: 'amI', code: 'AM-I', name: 'Applied Mathematics-I', iatMax: 20, eseMax: 60 },
    { id: 'ap', code: 'AP', name: 'Applied Physics', iatMax: 15, eseMax: 60 },
    { id: 'ac', code: 'AC', name: 'Applied Chemistry', iatMax: 15, eseMax: 60 },
    { id: 'em', code: 'EM', name: 'Engineering Mechanics', iatMax: 20, eseMax: 60 },
    { id: 'bee', code: 'BEE', name: 'Basic Electrical and Electronics Engineering', iatMax: 20, eseMax: 60 },
    { id: 'pce', code: 'PCE', name: 'Professional Communication and Ethics', iatMax: 15, eseMax: 60 }
  ],
  2: [
    { id: 'amII', code: 'AM-II', name: 'Applied Mathematics-II', iatMax: 20, eseMax: 60 },
    { id: 'apII', code: 'AP-II', name: 'Applied Physics-II', iatMax: 15, eseMax: 60 },
    { id: 'acII', code: 'AC-II', name: 'Applied Chemistry-II', iatMax: 15, eseMax: 60 },
    { id: 'eg', code: 'EG', name: 'Engineering Graphics', iatMax: 20, eseMax: 60 },
    { id: 'pps', code: 'PPS', name: 'Programming for Problem Solving', iatMax: 20, eseMax: 60 },
    { id: 'workshop', code: 'WS', name: 'Workshop Practice', iatMax: 15, eseMax: 60 }
  ]
};

export const normalizeSubjectKey = (value) => (
  String(value || '').trim().replace(/[^a-z0-9]/gi, '').toLowerCase()
);

export const createSubjectId = (subject = {}) => {
  const base = normalizeSubjectKey(subject.code || subject.name || Date.now());
  return base || `subject${Date.now()}`;
};

const toPositiveNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
};

export const normalizeSemesterSubject = (subject = {}) => {
  const iatFallback = toPositiveNumber(subject.iatMax || subject.total, 20);
  const iat1Max = toPositiveNumber(subject.iat1Max, iatFallback);
  const iat2Max = toPositiveNumber(subject.iat2Max, iatFallback);
  const eseMax = toPositiveNumber(subject.eseMax, 60);

  return {
    id: subject.id || createSubjectId(subject),
    code: subject.code || '',
    name: subject.name || '',
    iatMax: iat1Max,
    iat1Max,
    iat2Max,
    eseMax,
    teachingDivision: subject.teachingDivision || subject.division || '',
    courseInchargeEmail: subject.courseInchargeEmail || subject.facultyEmail || '',
    courseInchargeName: subject.courseInchargeName || subject.facultyName || ''
  };
};

export const getDefaultSubjects = (semester) => (
  DEFAULT_SEMESTER_SUBJECTS[Number(semester)] || DEFAULT_SEMESTER_SUBJECTS[1]
).map((subject) => normalizeSemesterSubject(subject));

export const getConfiguredSubjects = (semesterDoc, semester) => {
  const subjects = Array.isArray(semesterDoc?.subjects)
    ? semesterDoc.subjects
    : getDefaultSubjects(semester);

  return subjects
    .map(normalizeSemesterSubject)
    .filter((subject) => subject.code || subject.name);
};

export const getPerformanceRemark = (marks, maxMarks) => {
  if (marks === '' || marks === undefined || marks === null) return '-';

  const obtained = Number(marks);
  const maximum = Number(maxMarks);
  if (!Number.isFinite(obtained) || !Number.isFinite(maximum) || maximum <= 0) return '-';

  const percent = (obtained / maximum) * 100;
  if (percent < 40) return 'Failed';
  if (percent < 60) return 'Satisfactory';
  if (percent < 75) return 'Good';
  if (percent < 90) return 'Very Good';
  return 'Excellent';
};
